import { getCookie } from 'cookies';
import { View } from '../types/View';

export const getViewType = () => {
  const view = getCookie('srpView') || View.List;
  return `${view.charAt(0).toUpperCase()}${view.slice(1)}` as Lowercase<View>;
};
